import { FC } from 'react';
import { DefaultFooterComponent, PopupFooterProps, Validation } from '@silverfort/sf-components';
import { BindLocalAccountPopupState } from '../types';

type Props = PopupFooterProps<BindLocalAccountPopupState>;

const BindLocalAccountPopupFooter: FC<Props> = ({ popupState, ...props }) => {
    const { boundEntity } = popupState ?? {};

    return (
        <div className="flex justify-between items-center w-full h-full px-[-8px]">
            <Validation
                showIcon
                text="Only one user or group can be bound"
                className={`*:text-sf-neutral-500 transition-opacity ${boundEntity ? 'opacity-100' : 'opacity-0'}`}
            />
            <DefaultFooterComponent primaryButtonProps={{ text: 'Done', disabled: !boundEntity }} {...props} />
        </div>
    );
};

export default BindLocalAccountPopupFooter;
